import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import './assets/styles/layout.scss';
import './assets/demo/flags/flags.css';
import 'vue3-timepicker/dist/VueTimepicker.css'
import 'moment/locale/pt-br.js'

import moment from "moment";
import 'moment/locale/pt-br';

moment.locale("pt-br");

import { createApp, reactive } from 'vue';
import router from './router';
import AppWrapper from './AppWrapper.vue';
import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Badge from 'primevue/badge';
import BadgeDirective from 'primevue/badgedirective';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
import Chips from 'primevue/chips';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import Image from 'primevue/image';
import InlineMessage from 'primevue/inlinemessage';
import Inplace from 'primevue/inplace';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import Knob from 'primevue/knob';
import Galleria from 'primevue/galleria';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
import ScrollPanel from 'primevue/scrollpanel'
import ScrollTop from 'primevue/scrolltop';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import Skeleton from 'primevue/skeleton';
import SplitButton from 'primevue/splitbutton';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Steps from 'primevue/steps';
import StyleClass from 'primevue/styleclass';
import TabMenu from 'primevue/tabmenu';
import Tag from 'primevue/tag';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Timeline from 'primevue/timeline';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeSelect from 'primevue/treeselect';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import Editor from 'primevue/editor';
import FocusTrap from 'primevue/focustrap';
import BlockUI from 'primevue/blockui';
import SpeedDial from 'primevue/speeddial';

import CodeHighlight from './AppCodeHighlight';
import BlockViewer from './BlockViewer';

import TranslateVue from "./components/Translate.vue";
import EntidadeBox from "./components/EntidadeBox.vue";
import ContatoBox from "./components/ContatoBox.vue";
import ContadorBox from "./components/ContadorBox.vue";
import SituacaoBox from "./components/SituacaoBox.vue";
import DocumentoBox from "./components/Dropdowns/DocumentoBox.vue";
import TipoDocumentoBox from "./components/Dropdowns/TipoDocumentoBox.vue";
import DefContribBox from "./components/Dropdowns/DefContribBox.vue";
import GrupoDefContribBox from "./components/Dropdowns/GrupoDefContribBox.vue";
import EstadoBox from "./components/Dropdowns/EstadoBox.vue";
import NomeTela from "./components/Padrao/NomeTela.vue";
import Label from "./components/Padrao/Label.vue";
import TituloDialog from "./components/Padrao/TituloDialog.vue";
import SimNaoBox from "./components/Dropdowns/SimNaoBox/Index.vue";
import TipoPagamentoBox from "./components/Dropdowns/TipoPagamentoBox/Index.vue";
import InputDate from "./components/Padrao/InputDate/Index.vue";
import InputMessage from "./components/Padrao/mensagem-input/Index.vue";
import PlanoSaudeBox from "./components/Dropdowns/PlanoSaudeBox/Index.vue";
import DiaMesBox from "./components/Dropdowns/DiaMesBox/Index.vue";
import TipoDissidioBox from "./components/Dropdowns/TipoDissidioBox/Index.vue";
import BaseTela from "./components/Padrao/BaseTela.vue";

import VueTimepicker from 'vue3-timepicker'

import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBookmark, faKeyboard, faRectangleList, far } from '@fortawesome/free-regular-svg-icons'
import {
    faWrench, faSearch, faPenFancy, faMarker, faShoppingCart, faCog, faCalendar, faCalculator, faMapMarker,
    faDollar, fas,
    faBalanceScale,
    faSliders,
    faUniversity,
    faSuitcase,
    faPieChart,
    faPrint,
    faFlag,
    faEnvelope,
    faCommenting,
    faHeartbeat,
    faGavel,
    faTruck,
    faPaw,
    faBullhorn,
    faFileArchive,
    faIndustry,
    faBuilding,
} from '@fortawesome/free-solid-svg-icons';

import Login from './mixins/Login';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

library.add(
    faBookmark, faKeyboard, faWrench, faSearch, faPenFancy, faMarker,
    faCog, far, fas,
    faShoppingCart,
    faCalendar,
    faCalculator,
    faMapMarker,
    faDollar,
    faBalanceScale,
    faSliders,
    faUniversity,
    faSuitcase,
    faPieChart,
    faPrint,
    faFlag,
    faEnvelope,
    faCommenting,
    faHeartbeat,
    faGavel,
    faTruck,
    faPaw,
    faBullhorn,
    faFileArchive,
    faIndustry,
    faBuilding,
    faRectangleList
)

router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    next();
});

const app = createApp(AppWrapper);

app.config.globalProperties.$appState = reactive({ theme: 'lara-light-indigo', darkTheme: false });
app.config.globalProperties.$csrfCookie = reactive({ checked : false });
app.config.globalProperties.$user = reactive(null);

app.use(PrimeVue,
    {
        ripple: true, inputStyle: 'outlined',
        locale: {
            startsWith: 'Starts with',
            contains: 'Contains',
            notContains: 'Not contains',
            endsWith: 'Ends with',
            equals: 'Equals',
            notEquals: 'Not equals',
            noFilter: 'No Filter',
            lt: 'Less than',
            lte: 'Less than or equal to',
            gt: 'Greater than',
            gte: 'Greater than or equal to',
            dateIs: 'Date is',
            dateIsNot: 'Date is not',
            dateBefore: 'Date is before',
            dateAfter: 'Date is after',
            clear: 'Limpar',
            apply: 'Apply',
            matchAll: 'Match All',
            matchAny: 'Match Any',
            addRule: 'Add Rule',
            removeRule: 'Remove Rule',
            accept: 'Yes',
            reject: 'No',
            choose: 'Choose',
            upload: 'Upload',
            cancel: 'Cancel',
            completed: 'Completed',
            pending: 'Pending',
            dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sá'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            chooseYear: 'Escolha o ano',
            chooseMonth: 'Escolha o mês',
            chooseDate: 'Escolha a data',
            prevDecade: 'Previous Decade',
            nextDecade: 'Next Decade',
            prevYear: 'Previous Year',
            nextYear: 'Next Year',
            prevMonth: 'Previous Month',
            nextMonth: 'Next Month',
            prevHour: 'Previous Hour',
            nextHour: 'Next Hour',
            prevMinute: 'Previous Minute',
            nextMinute: 'Next Minute',
            prevSecond: 'Previous Second',
            nextSecond: 'Next Second',
            am: 'am',
            pm: 'pm',
            today: 'Hoje',
            weekHeader: 'Wk',
            firstDayOfWeek: 0,
            dateFormat: 'mm/dd/yy',
            weak: 'Weak',
            medium: 'Medium',
            strong: 'Strong',
            passwordPrompt: 'Enter a password',
            emptyFilterMessage: 'No results found', // @deprecated Use 'emptySearchMessage' option instead.
            searchMessage: '{0} results are available',
            selectionMessage: '{0} items selected',
            emptySelectionMessage: 'No selected item',
            emptySearchMessage: 'No results found',
            emptyMessage: 'No available options',
            aria: {
                trueLabel: 'True',
                falseLabel: 'False',
                nullLabel: 'Not Selected',
                star: '1 star',
                stars: '{star} stars',
                selectAll: 'All items selected',
                unselectAll: 'All items unselected',
                close: 'Close',
                previous: 'Previous',
                next: 'Next',
                navigation: 'Navigation',
                scrollTop: 'Scroll Top',
                moveTop: 'Move Top',
                moveUp: 'Move Up',
                moveDown: 'Move Down',
                moveBottom: 'Move Bottom',
                moveToTarget: 'Move to Target',
                moveToSource: 'Move to Source',
                moveAllToTarget: 'Move All to Target',
                moveAllToSource: 'Move All to Source',
                pageLabel: '{page}',
                firstPageLabel: 'First Page',
                lastPageLabel: 'Last Page',
                nextPageLabel: 'Next Page',
                prevPageLabel: 'Previous Page',
                rowsPerPageLabel: 'Rows per page',
                previousPageLabel: 'Previous Page',
                jumpToPageDropdownLabel: 'Jump to Page Dropdown',
                jumpToPageInputLabel: 'Jump to Page Input',
                selectRow: 'Row Selected',
                unselectRow: 'Row Unselected',
                expandRow: 'Row Expanded',
                collapseRow: 'Row Collapsed',
                showFilterMenu: 'Show Filter Menu',
                hideFilterMenu: 'Hide Filter Menu',
                filterOperator: 'Filter Operator',
                filterConstraint: 'Filter Constraint',
                editRow: 'Row Edit',
                saveEdit: 'Save Edit',
                cancelEdit: 'Cancel Edit',
                listView: 'List View',
                gridView: 'Grid View',
                slide: 'Slide',
                slideNumber: '{slideNumber}',
                zoomImage: 'Zoom Image',
                zoomIn: 'Zoom In',
                zoomOut: 'Zoom Out',
                rotateRight: 'Rotate Right',
                rotateLeft: 'Rotate Left'
            }
        }
    }
);
app.use(ConfirmationService);
app.use(ToastService);
app.use(router);
app.use(VueTimepicker)

app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);
app.directive('code', CodeHighlight);
app.directive('badge', BadgeDirective);
app.directive('styleclass', StyleClass);
app.directive('focustrap', FocusTrap);

app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
app.component('Avatar', Avatar);
app.component('AvatarGroup', AvatarGroup);
app.component('Badge', Badge);
app.component('Breadcrumb', Breadcrumb);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
app.component('Carousel', Carousel);
app.component('Chart', Chart);
app.component('Checkbox', Checkbox);
app.component('Chip', Chip);
app.component('Chips', Chips);
app.component('ColorPicker', ColorPicker);
app.component('Column', Column);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ConfirmPopup', ConfirmPopup);
app.component('ContextMenu', ContextMenu);
app.component('DataTable', DataTable);
app.component('DataView', DataView);
app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('Dialog', Dialog);
app.component('Divider', Divider);
app.component('Dropdown', Dropdown);
app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
app.component('Image', Image);
app.component('InlineMessage', InlineMessage);
app.component('Inplace', Inplace);
app.component('InputMask', InputMask);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
app.component('Galleria', Galleria);
app.component('Knob', Knob);
app.component('Listbox', Listbox);
app.component('MegaMenu', MegaMenu);
app.component('Menu', Menu);
app.component('Menubar', Menubar);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('OrderList', OrderList);
app.component('OrganizationChart', OrganizationChart);
app.component('OverlayPanel', OverlayPanel);
app.component('Paginator', Paginator);
app.component('Panel', Panel);
app.component('PanelMenu', PanelMenu);
app.component('Password', Password);
app.component('PickList', PickList);
app.component('ProgressBar', ProgressBar);
app.component('ProgressSpinner', ProgressSpinner);
app.component('RadioButton', RadioButton);
app.component('Rating', Rating);
app.component('SelectButton', SelectButton);
app.component('ScrollPanel', ScrollPanel);
app.component('ScrollTop', ScrollTop);
app.component('Slider', Slider);
app.component('Sidebar', Sidebar);
app.component('Skeleton', Skeleton);
app.component('SplitButton', SplitButton);
app.component('Splitter', Splitter);
app.component('SplitterPanel', SplitterPanel);
app.component('Steps', Steps);
app.component('TabMenu', TabMenu);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Tag', Tag);
app.component('Textarea', Textarea);
app.component('TieredMenu', TieredMenu);
app.component('Timeline', Timeline);
app.component('Toast', Toast);
app.component('Toolbar', Toolbar);
app.component('ToggleButton', ToggleButton);
app.component('Tree', Tree);
app.component('TreeSelect', TreeSelect);
app.component('TreeTable', TreeTable);
app.component('TriStateCheckbox', TriStateCheckbox);
app.component('Editor', Editor);
app.component('BlockUI', BlockUI);
app.component('SpeedDial', SpeedDial);

app.component('BlockViewer', BlockViewer);

app.component('Translate', TranslateVue);
app.component('EntidadeBox', EntidadeBox);
app.component('ContatoBox', ContatoBox);
app.component('ContadorBox', ContadorBox);
app.component('SituacaoBox', SituacaoBox);
app.component('DocumentoBox', DocumentoBox);
app.component('TipoDocumentoBox', TipoDocumentoBox);
app.component('DefContribBox', DefContribBox);
app.component('GrupoDefContribBox', GrupoDefContribBox);
app.component('EstadoBox', EstadoBox);
app.component('NomeTela', NomeTela);
app.component('Label', Label);
app.component('TituloDialog', TituloDialog);
app.component('SimNaoBox', SimNaoBox);
app.component('TipoPagamentoBox', TipoPagamentoBox);
app.component('InputDate', InputDate);
app.component('InputMessage', InputMessage);
app.component('PlanoSaudeBox', PlanoSaudeBox);
app.component('DiaMesBox', DiaMesBox);
app.component('TipoDissidioBox', TipoDissidioBox);
app.component('BaseTela', BaseTela);

/* add font awesome icon component */
app.component('font-awesome-icon', FontAwesomeIcon)

app.component('Datepicker', Datepicker);

if (process.env.VUE_APP_AUTH0_ENABLED) {
    console.log("Autho enabled");
    import('@auth0/auth0-vue')
    .then(module => {
        app.use(
            module.createAuth0({
                domain: process.env.VUE_APP_AUTH0_DOMAIN,
                clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
                authorizationParams: {
                    redirect_uri: process.env.VUE_APP_AUTH0_REDIRECT_URI
                }
            })
        );
    });
}
else {
    console.log("Auth0 disabled");
}

app.mount('#app');